webpackJsonp([20],{

/***/ 236:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_map_fields__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_click_outside__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_click_outside__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      toTopShow: false,
      boxName: ''
    };
  },

  props: ['productId', 'optionId', 'showOption'],
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('category', ['categoryList']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('product', ['finish']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex_map_fields__["b" /* mapFields */])('product', {
    product: 'productDetail'
  }), Object(__WEBPACK_IMPORTED_MODULE_3_vuex_map_fields__["c" /* mapMultiRowFields */])('product', {
    options: 'productDetail.ProductsOptions'
  }), {
    canSetBoxName: function canSetBoxName() {
      var _this = this;

      var cats = this.categoryList.filter(function (a) {
        return a.CategoryId === _this.product.CategoryId;
      });
      if (cats.length < 1) {
        return false;
      }
      var canSet = cats[0].FSetBoxName;
      return canSet !== undefined && canSet !== null && canSet === true;
    },
    enabledOptions: function enabledOptions() {
      return this.options.filter(function (a) {
        return a.NotAllowChange === false;
      });
    },
    totalPrice: function totalPrice() {
      var selOptionIds = this.product.OptionsVariantIds;
      var needOptions = this.product.ProductsOptions;
      if (needOptions === null || needOptions === undefined || needOptions.length < 1) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.product.BasePrice * this.product.quantity).toFixed(2);
      }
      var price = 0.0;
      for (var i = 0; i < needOptions.length; i++) {
        var vars = needOptions[i].Variants;
        for (var j = 0; j < vars.length; j++) {
          if (selOptionIds.indexOf(vars[j].OptionsVariantId) > -1) {
            price += vars[j].OptionsVariantPrice;
          }
        }
      }
      var subprice = this.product.BasePrice + price;
      var tmpPrice = subprice * this.product.quantity;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(tmpPrice).toFixed(2);
    },
    enableOption: function enableOption() {
      return this.showOption !== false;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('product', ['changeQuantity', 'selectOption', 'resetOption']), {
    addProductToCart: function addProductToCart() {
      var _this2 = this;

      if (!this.finish) {
        return;
      }
      var cartProduct = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.product));
      cartProduct.OptionsVariantIds = cartProduct.OptionsVariantIds.filter(function (a) {
        return a > 0;
      });
      cartProduct = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
        BoxName: this.boxName,
        Qty: cartProduct.quantity,
        IsQuickOrder: !this.enableOption
      }, cartProduct);
      this.$store.dispatch('cart/addProductToCart', cartProduct).then(function () {
        document.body.style.position = 'initial';
        document.body.style.overflow = 'auto';
        document.querySelector('.fc-product-customize >div').removeEventListener('scroll', _this2.handleScroll);
        _this2.$emit('cancel');
      });
    },
    handleScroll: function handleScroll() {
      this.scrollTop = document.querySelector('.fc-product-customize >div').scrollTop;
      this.toTopShow = this.scrollTop > 50;
    },
    cancel: function cancel() {
      document.body.style.position = 'initial';
      document.body.style.overflow = 'auto';
      document.querySelector('.fc-product-customize >div').removeEventListener('scroll', this.handleScroll);
      this.$emit('cancel');
    }
  }),
  created: function created() {
    var data = {
      productId: this.productId,
      optionId: this.optionId
    };
    this.$store.dispatch('product/getProductDetails', data);

    document.body.style.position = 'fixed';
    document.body.style.overflow = 'hidden';
    this.$nextTick(function () {
      document.querySelector('.fc-product-customize >div').addEventListener('scroll', this.handleScroll);
    });
  },
  destoryed: function destoryed() {
    document.body.style.position = 'initial';
    document.body.style.overflow = 'auto';
    document.querySelector('.fc-product-customize >div').removeEventListener('scroll', this.handleScroll);
  },

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_5_vue_click_outside___default.a
  }
});

/***/ }),

/***/ 242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Customize_vue__ = __webpack_require__(236);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47111eb9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Customize_vue__ = __webpack_require__(243);
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Customize_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47111eb9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Customize_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fc-product-customize",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.cancel($event)}}},[_c('div',{attrs:{"tabindex":"0"}},[_c('div',{class:{ 'fc-header': true, 'fc-fixed': _vm.toTopShow }},[_c('div',[_vm._v(_vm._s(_vm.product.ProductName)+" - "),_c('span',[_vm._v(_vm._s(_vm.product.ProductsMainOptionName))])]),_vm._v(" "),_c('a',{on:{"click":_vm.cancel}})]),_vm._v(" "),_c('div',{staticClass:"fc-content"},[_vm._l((_vm.enabledOptions),function(option){return (_vm.enableOption)?_c('div',{staticClass:"fc-item"},[_c('label',[_vm._v(_vm._s(option.ProductsOptionName)+" "),(option.ChooseOptionLabel != null && option.ChooseOptionLabel != '')?_c('span',[_vm._v("("+_vm._s(option.ChooseOptionLabel)+")")]):_vm._e(),(option.SetToStandardLabel != '')?_c('a',{on:{"click":function($event){return _vm.resetOption(option)}}},[_vm._v(_vm._s(option.SetToStandardLabel))]):_vm._e()]),_vm._v(" "),_c('ul',_vm._l((option.Variants),function(item){return _c('li',{class:{ 'fc-active': _vm.product.OptionsVariantIds.includes(item.OptionsVariantId), 'fc-non': item.PhotoKey == '' },on:{"click":function($event){return _vm.selectOption(item.OptionsVariantId)}}},[(item.PhotoKey == '')?_c('div',[_c('i',{staticClass:"icon-ico-non"})]):_vm._e(),_vm._v(" "),(item.PhotoKey != '')?_c('img',{attrs:{"src":item.PhotoKey}}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.OptionsVariantName))]),_vm._v(" "),(item.OptionsVariantPrice > 0)?_c('span',{staticClass:"fc-price"},[_vm._v("$"+_vm._s(_vm._f("price")(item.OptionsVariantPrice)))]):_vm._e()])}),0)]):_vm._e()}),_vm._v(" "),(_vm.canSetBoxName)?_c('div',{staticClass:"fc-item"},[_c('label',[_vm._v("Enter a name to identify this lunchbox")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.boxName),expression:"boxName"}],attrs:{"type":"text"},domProps:{"value":(_vm.boxName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.boxName=$event.target.value}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"fc-item"},[_c('label',[_vm._v("Quantity")]),_vm._v(" "),_c('div',{staticClass:"fc-quantity"},[_c('a',{class:{'fc-active': (_vm.product.quantity > 1)},on:{"click":function($event){(_vm.product.quantity) > 1 ? (_vm.changeQuantity(_vm.product.quantity - 1)) : _vm.changeQuantity(1)}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.product.quantity))]),_vm._v(" "),_c('a',{staticClass:"fc-active",on:{"click":function($event){return _vm.changeQuantity(_vm.product.quantity + 1)}}})])])],2),_vm._v(" "),_c('div',{staticClass:"fc-control"},[_c('a',{attrs:{"disabled":!_vm.finish},on:{"click":_vm.addProductToCart}},[_c('span',[_vm._v("Add to cart")]),_vm._v(" "),_c('span',[_vm._v("$"+_vm._s(_vm.totalPrice))])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 399:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AlaCarte_vue__ = __webpack_require__(400);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5288dcd4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AlaCarte_vue__ = __webpack_require__(452);
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AlaCarte_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5288dcd4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AlaCarte_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 400:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_map_fields__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Customize__ = __webpack_require__(242);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ala-carte',
  components: {
    'fc-customize': __WEBPACK_IMPORTED_MODULE_2__Customize__["a" /* default */]
  },
  data: function data() {
    return {
      showCustomize: false,
      productId: 0,
      optionId: 0
    };
  },

  methods: {
    makeCustomize: function makeCustomize(product) {
      var _this = this;

      var optionId = product.ProductsMainOptions.length > 0 ? product.ProductsMainOptions[0].ProductsMainOptionId : 0;

      var data = {
        productId: product.ProductId,
        optionId: optionId
      };
      this.$store.dispatch('product/getProductDetails', data).then(function (a) {
        if (a.ProductsOptions !== null && a.ProductsOptions.length > 0) {
          _this.productId = product.ProductId;
          _this.optionId = optionId;
          _this.showCustomize = true;
        } else {
          _this.addToCart(product);
        }
      });
    },
    addToCart: function addToCart(product) {
      var optionId = product.ProductsMainOptions.length > 0 ? product.ProductsMainOptions[0].ProductsMainOptionId : 0;
      var data = {
        ProductId: product.ProductId,
        ProductsMainOptionId: optionId,
        Qty: product.quantity,
        OptionsVariantIds: [],
        BoxName: ''
      };
      this.$store.dispatch('cart/addProductToCart', data);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex_map_fields__["c" /* mapMultiRowFields */])('product', {
    products: 'products.Products'
  }))
});

/***/ }),

/***/ 452:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fc-alacarte-container"},[_c('div',{staticClass:"fc-product-list"},[(_vm.products != null && _vm.products != undefined && _vm.products.length > 0)?_c('div',{staticClass:"fc-list"},_vm._l((_vm.products),function(item){return _c('div',[_c('div',[_c('img',{attrs:{"src":item.PhotoKey}})]),_vm._v(" "),_c('div',[_c('div',{staticClass:"fc-title"},[_vm._v(_vm._s(item.ProductName))]),_vm._v(" "),_c('div',{staticClass:"fc-price"},[_vm._v("$"+_vm._s(item.ProductsMainOptions[0].BasePrice.toFixed(2)))]),_vm._v(" "),_c('div',{staticClass:"fc-desc",domProps:{"innerHTML":_vm._s(item.Description.replace(/\r\n/g, '<br/>'))}}),_vm._v(" "),_c('div',{staticClass:"fc-add-to-cart"},[_c('div',{staticClass:"fc-quantity"},[_c('a',{class:{'fc-active': (item.quantity > 1)},on:{"click":function($event){(item.quantity) > 1 ? (item.quantity -= 1) : 1}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.quantity))]),_vm._v(" "),_c('a',{staticClass:"fc-active",on:{"click":function($event){item.quantity += 1}}})]),_vm._v(" "),_c('div',{staticClass:"fc-control",on:{"click":function($event){return _vm.makeCustomize(item)}}},[_vm._v("\n\t\t\t\t\t\t\tADD TO CART\n\t\t\t\t\t\t")])])])])}),0):_vm._e()]),_vm._v(" "),(_vm.showCustomize)?_c('fc-customize',{attrs:{"productId":_vm.productId,"optionId":_vm.optionId},on:{"cancel":function($event){_vm.showCustomize = false}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/20.js?v=1698631571653